/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, disable } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTENT ANALYTICS CARD : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    storyanalyticscard: {
        '& .title-container': {
            display: 'flex',
            marginBottom: pxToEm(13),
            '& .image': {
                flexShrink: 0,
                backgroundColor: 'transparent',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50%',
                backgroundSize: 'cover',
                borderRadius: pxToEm(5),
                width: pxToEm(75),
                height: pxToEm(75),
                marginRight: pxToEm(17)
            },
            '& .title':{
                extend: theme.typography.size.small,
                lineHeight: '1.3'
            }
        },
        '& .link':{
            whiteSpace: 'normal'
        },
        '& .clicks': {
            display: 'flex',
            '& a': {
                padding: replacePXinStringWithEM('13px 12px'),
                backgroundColor: theme.color.system.light.swatch,
                border: replacePXinStringWithEM('1px solid #f5f5f5'),
                width:'100%',
                justifyContent: 'space-between',
                '&:hover': {
                    filter: 'brightness(130%) !important',
                },
                '& .title': {
                  alignSelf: 'flex-start'
                },
                '& .count-container': {
                    textAlign: 'right',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    '& .count': {
                        extend: theme.typography.size.xxlarge,
                        color: theme.color.system.light.contrast,
                        fontWeight: '700'
                    },
                    '& .analytics-link': {
                        extend: theme.typography.size.small,
                        color: theme.color.system.light.contrast
                    }
                }
            }
        }
    }
})